export default __webpack_public_path__ + "static/media/threejs.555666bc.png";